import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./App.css";
import FeeReceiptUI from "./FeeUI";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const StudentReceipt = () => {
  const { transaction_id } = useParams();
  const navigate = useNavigate();
  const [receiptData, setReceiptData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const donorId = sessionStorage.getItem("donorName");

  const fetchReceiptData = useCallback(async () => {
        const decodeID = atob(transaction_id);
     // console.log("API CALLEDdecodeID");
     // console.log(decodeID);

    try {

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/armedforces-api/getFeeReceipt/${transaction_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      if (result.length > 0) {
        setReceiptData(result[0]);
      } else {
        setReceiptData(null);
      }
    } catch (error) {
      console.error("Error fetching fee receipt:", error);
    } finally {
      setIsLoading(false);
    }
  }, [transaction_id]);

  useEffect(() => {
    if (!donorId) {
      navigate("/armedforces");
    } else {
      fetchReceiptData();
    }
  }, [donorId, fetchReceiptData, navigate]);

  const sendEReceipt = async (receiptData) => {
    const receiptElement = document.querySelector(".receipt-container");
    if (!receiptElement) {
      console.error("Receipt container not found.");
      return;
    }

  try {
      const downloadBtn = document.querySelector(".action-btn");


  // Hide the download button
 // downloadBtn.style.display = "none";
      const canvas = await html2canvas(receiptElement, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL("image/jpeg", 0.3);
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      // Calculate the aspect ratio to fit the content within the PDF page
      const ratio = Math.min(pdfWidth / canvasWidth, pdfHeight / canvasHeight);

      // Add the image to the PDF, centered
      const imgWidth = canvasWidth * ratio;
      const imgHeight = canvasHeight * ratio;
      const xOffset = (pdfWidth - imgWidth) / 2; // Center horizontally
      const yOffset = 0; // Start from the top

      pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);
      const pdfBlob = pdf.output("blob");

      const formData = new FormData();
      formData.append("file", pdfBlob, `${receiptData.transaction_id}_Receipt.pdf`);
      formData.append("name", receiptData.donor_name || "Unknown Donor");
      formData.append("email", receiptData.email || "no_email@example.com");
      formData.append("transaction_id", receiptData.transaction_id);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/armedforces-api/send-receipt`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Receipt submission failed! Status: ${response.status}`);
      }

     // console.log("Receipt sent successfully!");
    } catch (error) {
      console.error("Error sending receipt:", error);
    }
  };

  return (
    <div className="full-receipt">
      <FeeReceiptUI
        receiptData={receiptData}
        isLoading={isLoading}
        sendEReceipt={sendEReceipt}
      />
    </div>
  );
};

export default StudentReceipt;

